/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Role_AssignedInputs */

const en_admin_users_role_assigned = /** @type {(inputs: Admin_Users_Role_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role assigned`)
};

const zh_admin_users_role_assigned = /** @type {(inputs: Admin_Users_Role_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色已分配`)
};

/**
* | output |
* | --- |
* | "Role assigned" |
*
* @param {Admin_Users_Role_AssignedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_role_assigned = /** @type {((inputs?: Admin_Users_Role_AssignedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Role_AssignedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_role_assigned(inputs)
	return zh_admin_users_role_assigned(inputs)
});
export { admin_users_role_assigned as "admin.users.role_assigned" }